import React, { useState } from 'react';
import { Container, Box, Tabs, Tab, Snackbar, Alert } from '@mui/material';
import NavBar from '../components/NavBar';
import CompanyDetails from '../components/CompanyDetails';
import Departments from '../components/Departments';
import TeamMembers from '../components/TeamMembers';
import ProjectTeams from '../components/ProjectTeams';
import UserComponent from '../components/UserComponent';

const Admin = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  return (
    <Container>
      <NavBar username="Admin" initial="A" /> {/* Use NavBar component */}
      
      <Tabs value={tabIndex} onChange={handleTabChange} aria-label="admin tabs" sx={{ marginBottom: 2 }}>
        <Tab label="Users" sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.87)' }} />
        <Tab label="Company" sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.87)' }} />
        <Tab label="Departments" sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.87)' }} />
        <Tab label="Team Members" sx={{ fontWeight: 'bold', color: 'rgba(0, 0, 0, 0.87)' }} />
       
      </Tabs>
    
      {tabIndex === 0 && (
        <Box mt={2}>
          <UserComponent />
        </Box>
      )}
      {tabIndex === 1 && (
        <Box mt={2}>
          <CompanyDetails />
        </Box>
      )}
      {tabIndex === 2 && (
        <Box mt={2}>
          <Departments />
        </Box>
      )}
      {tabIndex === 3 && (
        <Box mt={2}>
          <TeamMembers />
        </Box>
      )}
     
      <Snackbar open={snackbar.open} autoHideDuration={6000} onClose={handleCloseSnackbar}>
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Admin;